import { useEffect, useState } from "react";
import { api } from "../api/client";

/**
 * Адрес фото в памяти браузера. Браузер не прикладывает токен к <img src>
 * и ссылкам, поэтому файл загружается запросом с авторизацией.
 */
function usePhotoUrl(id: string | null): { url: string | null; failed: boolean } {
  const [url, setUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let objectUrl: string | null = null;
    let cancelled = false;
    setUrl(null);
    setFailed(false);
    if (!id) return;
    api.blob(`/api/v1/files/${id}/download`).then(
      (blob) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      },
      () => !cancelled && setFailed(true),
    );
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [id]);

  return { url, failed };
}

/** Снимок в карточке: открывается в полный размер, оригинал можно скачать. */
export function Photo({ id }: { id: string }) {
  const { url, failed } = usePhotoUrl(id);

  if (failed) return <div className="map-empty small">Фото не загрузилось</div>;
  if (!url) return <div className="map-empty small">Загрузка фото…</div>;
  return (
    <figure style={{ margin: 0 }}>
      <a href={url} target="_blank" rel="noreferrer" title="Открыть в полном размере">
        <img src={url} alt="Фото с места" />
      </a>
      <figcaption className="small" style={{ marginTop: 4 }}>
        <a href={url} download={`${id}.jpg`}>Скачать оригинал</a>
      </figcaption>
    </figure>
  );
}

/** Миниатюра в строке списка. */
export function PhotoThumb({ id }: { id: string | null }) {
  const { url } = usePhotoUrl(id);
  if (!id) return <div className="thumb">нет фото</div>;
  return <div className="thumb">{url && <img src={url} alt="" />}</div>;
}
